<template>
    <swiper :options="options">
        <swiper-slide v-for="(s, i) in imgList" :key="i">
            <div class="carousel-item"
                 :style="{width: '100%', height: config.height + 'px'}">
                <div class="carousel-img" :style="{borderRadius: config.borderRadius + 'px', backgroundImage: `url(${s.url})`}"></div>
            </div>
        </swiper-slide>
    </swiper>
</template>

<script>
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css';

    export default {
        name: "carousel",
        components: {
            Swiper,
            SwiperSlide,
        },
        props: {
            config: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        computed: {
            imgList() {
                return this.config.imgList;
            },
            options() {
                return {
                    autoplay: this.config.auto ? {delay: this.config.delay * 1000} : false
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .carousel-img {
        width: 100%;
        height: 100%;
        background: center no-repeat;
        background-size: cover;
    }
</style>
